const generateShortName = (user = {}) => {
  if (!user) return "";
  const shortName =
    `${user.surname || ""} ` +
    `${(user.name && `${user.name[0]}. `) || ""}` +
    `${(user.lastName && `${user.lastName[0]}. `) || ""}`;
  return shortName.trim();
};

export default generateShortName;
